import { render, staticRenderFns } from "./solicitacaoIdenizatoriaValidaDespacho.vue?vue&type=template&id=007ad1b6&scoped=true&"
import script from "./solicitacaoIdenizatoriaValidaDespacho.vue?vue&type=script&lang=js&"
export * from "./solicitacaoIdenizatoriaValidaDespacho.vue?vue&type=script&lang=js&"
import style0 from "./solicitacaoIdenizatoriaValidaDespacho.vue?vue&type=style&index=0&id=007ad1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ad1b6",
  null
  
)

export default component.exports